export default "__VITE_ASSET__C_X1$3zy__"